import { Module, VuexModule, Mutation, Action, getModule } from 'vuex-module-decorators';
import store from '@/Pages/Admin/Store/index';
import { trekService } from '@/Pages/Admin/Modules/ManagePackage/Services/Trekservice';


@Module({ name: 'UserRoleInfo', namespaced: true, dynamic: true, store })
class UserRoleInfo extends VuexModule {
  public UserRole: any = [];
  public UserInfo: any = [];


  @Mutation
  public GET_USER_INFO(data: any) {
    this.UserInfo = data;
  }
  @Mutation
  public GET_USER_ROLE(data: any) {
    console.log("DATA", data);
    this.UserRole = data.role;
  }

  @Action
  public async GetPackageTitle(payLoad: object): Promise<any> {
    // return await new Promise((resolve, reject) => {
    //   trekService
    //     .getGeneralTabData(payLoad)
    //     .then((res: any) => {
          this.context.commit('GET_USER_INFO', payLoad);
          this.context.commit('GET_USER_ROLE', payLoad);
    //       // console.log("from store action" ,res.data.data);
    //       resolve(res);
    //     })
    //     .catch((error: any) => {
    //       reject(error);
    //     });
    // });

  }

}

export default getModule(UserRoleInfo);
